import axios from 'axios';

export default {
    methods: {
        async rolesIndex(d, ok, err) {
            try {
                let r = await axios.get('roles?page=' + d.page, {params: d});
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async rolesStore(params, ok, err) {
            try {
                let r = await axios.post('roles', params);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async rolesShow(id, ok, err) {
            try {
                let r = await axios.get('roles/' + id);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async rolesUpdate(params, ok, err) {
            try {
                let r = await axios.put('roles/' + params.id, params);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async rolesDestroy(id, ok, err) {
            try {
                let r = await axios.delete('roles/' + id);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async rolesList(ok, err) {
            try {
                let r = await axios.post('roles/list');
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async rolesPermissions(d, ok, err) {
            try {
                let r = await axios.post('roles/permissions', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async rolesAttachPermissions(d, ok, err) {
            try {
                let r = await axios.post('roles/attach-permission', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async rolesPermissionsSync(d, ok, err) {
            try {
                let r = await axios.post('roles/permissions-sync', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async roleUsers(d, ok, err) {
            try {
                let r = await axios.post('roles/users', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async roleUsersSync(d, ok, err) {
            try {
                let r = await axios.post('roles/users-sync', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async rolesDescuentoSet(d, ok, err) {
            try {
                let r = await axios.post('roles/descuento-set', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async rolesDescuentoGet(d, ok, err) {
            try {
                let r = await axios.post('roles/descuento-get', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        }
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/mixins/auth/roles.js